import { afterNextRender, DestroyRef, ElementRef, inject, Signal, WritableSignal } from '@angular/core';

export const RAIL_DOCK_MAX_WIDTH = 1440;
export const RAIL_DOCK_HYSTERESIS = 32;

/** Dock below 1440, stay docked until width clears 1440+hysteresis so ResizeObserver cannot flip-flop. */
export function nextRailDock(width: number, currentlyDocked: boolean, maxWidth = RAIL_DOCK_MAX_WIDTH, hysteresis = RAIL_DOCK_HYSTERESIS): boolean {

  return currentlyDocked ? width <= maxWidth + hysteresis : width <= maxWidth;
}

/**
 * Keeps a host's rail dock state in step with the host element's width: measured once after first render, then on every resize.
 * Docking re-opens a pinned rail that was collapsed, so a pinned rail never hides when the host narrows. Called from the Detail
 * and workflow editor host constructors; the observer stops with the host.
 */
export function bindRailDock(rail: { docked: WritableSignal<boolean>; pinned: Signal<boolean>; collapsed: WritableSignal<boolean> }): void {

  const host = (inject(ElementRef) as ElementRef<HTMLElement>).nativeElement;
  const destroyRef = inject(DestroyRef);
  afterNextRender(() => {
    const sync = () => {
      const docked = nextRailDock(host.clientWidth, rail.docked());
      if (docked !== rail.docked()) rail.docked.set(docked);
      if (docked && rail.pinned() && rail.collapsed()) rail.collapsed.set(false);
    };
    sync();
    const observer = new ResizeObserver(() => sync());
    observer.observe(host);
    destroyRef.onDestroy(() => observer.disconnect());
  });
}
